import { initialProfilesState } from 'redux/initialState';
import { status } from 'constants/general';

import profilesActionTypes from './action-types';

const profilesReducer = (state = initialProfilesState, { type, payload }) => {
  switch (type) {
    case profilesActionTypes.FETCH_PROFILE_DETAILS:
      return {
        ...state,
        profileDetails: {
          status: status.FETCHING,
        },
      };

    case profilesActionTypes.FETCH_PROFILE_DETAILS_SUCCESS:
      return {
        ...state,
        profileDetails: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case profilesActionTypes.FETCH_PROFILE_DETAILS_FAIL:
      return {
        ...state,
        profileDetails: {
          status: status.FAIL,
        },
      };

    case profilesActionTypes.FETCH_UPDATE_PROFILE_INFO:
      return {
        ...state,
        updateProfileInfo: {
          status: status.FETCHING,
        },
      };

    case profilesActionTypes.FETCH_UPDATE_PROFILE_INFO_SUCCESS:
      return {
        ...state,
        updateProfileInfo: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case profilesActionTypes.FETCH_UPDATE_PROFILE_INFO_FAIL:
      return {
        ...state,
        updateProfileInfo: {
          status: status.FAIL,
        },
      };

    default:
      return state;
  }
};

export default profilesReducer;
